"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
let RowDetailTrial = class RowDetailTrial extends vue_property_decorator_1.Vue {
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 3 })
], RowDetailTrial.prototype, "locations", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 4 })
], RowDetailTrial.prototype, "times", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 2 })
], RowDetailTrial.prototype, "treatment", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], RowDetailTrial.prototype, "totalSamples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'See Details' })
], RowDetailTrial.prototype, "textAction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '---' })
], RowDetailTrial.prototype, "nameTrial", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'General Crop' })
], RowDetailTrial.prototype, "cropName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], RowDetailTrial.prototype, "cropLogoName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: ['Calabassas Parcel', 'One Parcel', 'SeconParcel'] })
], RowDetailTrial.prototype, "locationsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
        default: [
            { time: 1, date: 'Apr2023' },
            { time: 2, date: 'Apr2023' },
            { time: 3, date: 'Apr2023' },
        ],
    })
], RowDetailTrial.prototype, "timesList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: ['ControlOne', 'ControlTwo'] })
], RowDetailTrial.prototype, "treatmentsList", void 0);
RowDetailTrial = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ListItem: bmk_ui_framework_1.ListItem,
            List: bmk_ui_framework_1.List,
            Dropdown: floating_vue_1.Dropdown,
            PinIcon: bmk_ui_framework_1.PinIcon,
            ListIcon: bmk_ui_framework_1.ListIcon,
            PairIcon: bmk_ui_framework_1.PairIcon,
            DateStylized: bmk_ui_framework_1.DateStylized,
            Button: bmk_ui_framework_1.Button,
        },
    })
], RowDetailTrial);
exports.default = RowDetailTrial;
